<div class="wrapper">
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    <mat-tab label="Создать новый">
      <div class="header">
        Выбрана реклама с Id: {{ recordData().id }}
      </div>
      <mat-form-field
        class="field"
        appearance="outline"
      >
        <input
          matInput
          [(ngModel)]="packageName"
        >
        <mat-label>Название пакета (необязательно)</mat-label>
      </mat-form-field>
    </mat-tab>
    <mat-tab label="Выбрать существующий">
      <div class="header">
        Выбрана реклама с Id: {{ recordData().id }}
      </div>
      <mat-form-field
        class="search"
        appearance="outline"
      >
        <input
          #searchInput
          matInput
          placeholder="Поиск"
          [(ngModel)]="searchPackage"
          (blur)="loadPackages()"
          (keyup.enter)="searchInput.blur()"
        >
        <mat-label>Введите название или id рекламного пакета</mat-label>
      </mat-form-field>
      <div class="content">
        <mat-selection-list
          [multiple]="false"
          [(ngModel)]="selectedPackages"
        >
          @for (advertisementPackage of packages; track $index) {
            <mat-list-option [value]="advertisementPackage">
              <div class="option">
              <span>
                id: {{ advertisementPackage.id }}
              </span>
              <span>
                {{ advertisementPackage['name'] }}
              </span>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
        @if (!hasPackages) {
          <div class="no-result">
            Нет рекламный пакетов с таким названием
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      color="primary"
      (click)="selectedTabIndex ? handleSelect() : handleCreate()"
    >
      {{ btnText }}
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="onCloseDialog.emit('cancel')"
    >
      Закрыть
    </button>
  </div>
</div>
